import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from '@/components/Layout';
import HomePage from '@/pages/HomePage';
import ProjectsPage from '@/pages/ProjectsPage';
import ProjectDetailPage from '@/pages/ProjectDetailPage';
import TasksPage from '@/pages/TasksPage';
import AgentsPage from '@/pages/AgentsPage';
import GuardsPage from '@/pages/GuardsPage';
import '@/App.css';

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/projetos" element={<ProjectsPage />} />
          <Route path="/projetos/:id" element={<ProjectDetailPage />} />
          <Route path="/tarefas" element={<TasksPage />} />
          <Route path="/agentes" element={<AgentsPage />} />
          <Route path="/guards" element={<GuardsPage />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
